//  Initialize the ts object if it exists
document.addEventListener('DOMContentLoaded', function () {
  if (window.ts !== undefined && typeof window.ts.load === 'function') {
    window.ts.init({ brokerCode: '1212121212121212' });
  } else {
    console.warn('ts.load is not a function. Ensure the ts object is properly initialized.');
  }
})

window.searchTariffs = () => {
  return {
    loading: false,
    mixed: false,
    showNote: false,
    isSelection: false,
    query: {
      value: '',
      id: null,
    },
    mixedFields: [{
      value: '',
      reference: '',
      id: '',
    }],
    toggleMixedMode() {
      if (!this.mixed) {
        this.mixedFields = [{}];
      }
    },
    addField() {
      this.mixedFields.push({
        value: '',
        id: '',
      });
    },
    removeField(index) {
      this.mixedFields.splice(index, 1);

      if(!this.mixedFields.length) {
        this.mixed = false;
        this.addField();
      }
    },
    async submit() {
      let formData = new FormData(this.$refs.form);
      let hasData = false;

      for (let data of formData.entries()) {
        if (data[0] === 'profession' && data[1] !== '' && data[1] !== undefined) {
          hasData = true;
        }
      }

      if (this.isSelection) {
        this.isSelection = false;
        return false;
      }

      if (!hasData) {
        this.showNote = true;
        return false;
      }

      this.loading = true;
      this.showNote = false;

      let response = await fetch(restObject.root + 'wp/v2/widget?' +  new URLSearchParams({
        professions: formData.getAll('profession'),
        product_id: formData.getAll('product_id'),
      }));

      let data = await response.json();
      this.loading = false;

      if (data && data.url) {
        window.location.href = (data.url);
      }
    }
  };
};

window.professions = () => {
  return {
    results: [],
    cursorIndex: -1,
    async get(query, $id, $reference) {
      if (!query || query == '') {
        this.results = [];
        $id.value = '';
        $reference.value = '';
        this.cursorIndex = -1;
        return;
      }

      if (query !== $reference.value) {
        $id.value = '';
        $reference.value = '';
      }

      this.noResults = false;
      this.loading = true;
      this.cursorIndex = -1;

      let response = await fetch(restObject.root + 'wp/v2/professions?' + new URLSearchParams({
        query: query,
      }));

      let data = await response.json();

      // The response will be a cleaned query string
      if (!response.ok) {
        this.loading = false;
        this.results = [];
        this.noResults = true;
        return;
      }

      if (data.query && typeof data.query === 'string') {
        const results = await window.ts.professionSearch(data.query);

        if (results) {
          this.results = results;

          // Return max 15 results
          if (this.results.length > 15) {
            this.results = this.results.slice(0, 15);
          }
        }
        else {
          this.results = [];
        }
      }

      this.loading = false;

      if (this.results.length) {
      }
      else {
        $id.value = '';
        $reference.value = '';
        this.results = [];
        this.noResults = true;
      }
    },
    highlight(content, query) {
      query = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const re = new RegExp(query, 'gi');

      if (query.length > 0) {
        return content.replace(re, `<mark>$&</mark>`);
      }
      else {
        return content;
      }
    },
    setValue(result, element, input, reference) {
      if(result) {
        element.value = result.alias;
        input.value = result.id;
        reference.value = result.alias;
        this.showNote = false;
        this.isSelection = true;
      }
      else if(this.results.length > 0 && this.cursorIndex >= 0) {
        element.value = this.results[this.cursorIndex]['alias'];
        input.value = this.results[this.cursorIndex]['id'];
        reference.value = this.results[this.cursorIndex]['alias'];
        this.showNote = false;
        this.isSelection = true;
      }

      this.results = [];
    },
    up() {
      if (this.results.length > 0 && this.cursorIndex > 0) {
        this.cursorIndex--;
        let oldActive = this.results.find(
          (result) => result.active
        );
        if (oldActive) {
          oldActive.active = false;
        }
        this.results[this.cursorIndex].active = true;
      }
    },
    down() {
      if (this.results.length > 0 && this.cursorIndex < this.results.length - 1) {
        this.cursorIndex++;
        let oldActive = this.results.find(
          (result) => result.active
        );
        if (oldActive) {
          oldActive.active = false;
        }
        this.results[this.cursorIndex].active = true;
      }
    },
  };
};
